import React, { useState, useEffect, useRef } from "react";
import DefaultButton from "../Buttons/DefaultButton/DefaultButton";
import { LuTrash2 } from "react-icons/lu";
import IconButton from "../Buttons/IconButton/IconButton";
import {Input} from "react-aria-components";
import "./DefaultTextListEditor.css"

function DefaultTextListEditor({ initialValuesList = [], onChange }: {
    initialValuesList?: string[];
    onChange?: (values: string[]) => void;
}) {
    // Keep local copy of the list
    const [items, setItems] = useState(initialValuesList);


    // Store refs so we can move focus to new inputs automatically
    const inputRefs = useRef([]);

    /** Fire the onChange callback whenever items change */
    useEffect(() => {
        if (typeof onChange === "function") {
            onChange(items);
        }
    }, [items, onChange]);

    /** Update a single item */
    const handleItemChange = (idx, value) => {
        setItems((prev) => {
            const next = [...prev];
            next[idx] = value;
            return next;
        });
    };

    /** Add a blank item to the end and focus it */
    const handleAddItem = () => {
        setItems((prev) => [...prev, ""]);
        // Wait for the DOM update, then focus the new input
        setTimeout(() => {
            inputRefs.current[inputRefs.current.length - 1]?.focus();
        }, 0);
    };

    /** Remove an item at the specified index */
    const handleRemoveItem = (idx) => {
        setItems((prev) => prev.filter((_, i) => i !== idx));
        // Optionally move focus to the next logical element
    };

    return (
        <div className="defaultTextListEditor">
            <ul className="verticalList" role="list" aria-label="Editable text list">
                {items.map((value, idx) => (
                    <li
                        key={idx}
                        className="textItem"
                    >
                        <Input
                            type="text"
                            aria-label={`Item ${idx + 1}`}
                            value={value}
                            ref={(el) => (inputRefs.current[idx] = el)}
                            onChange={(e) => handleItemChange(idx, e.target.value)}
                        />
                       <IconButton
                            icon={<LuTrash2/>}
                            onPress={() => handleRemoveItem(idx)}
                       />
                    </li>
                ))}
            </ul>

            <DefaultButton
                text="Add Schema"
                aria-label="Add Schema"
                onPress={handleAddItem}
            />
        </div>
    );
}

export default DefaultTextListEditor;
